import { render, staticRenderFns } from "./plessonword.vue?vue&type=template&id=853e9966&scoped=true&"
import script from "./plessonword.vue?vue&type=script&lang=js&"
export * from "./plessonword.vue?vue&type=script&lang=js&"
import style0 from "./plessonword.vue?vue&type=style&index=0&id=853e9966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853e9966",
  null
  
)

export default component.exports